import {
    SchedulingWorkshiftModelAPI,
    WorkshiftSchedulingsIds,
} from '../../../../models';
import { createWorkshiftsSchedulingAdapter } from '../../Adapters';
import { requests } from '../apiAgent';

interface CreateWorkshiftsSchedulingBody {
    workshiftId: number | undefined;
    startDate: string;
    endDate: string;
    employeeIds: (string | number)[];
}

interface DeleteWorkshiftsSchedulingBody {
    workshiftSchedulingIds: number[] | undefined;
}

export const WorkshiftsSchedulingAPI = {
    createSchedulings: (body: CreateWorkshiftsSchedulingBody) => {
        return requests
            .post(
                '/jerusalem/api/v2.0.0/workshift-schedulings/create-schedulings',
                body
            )
            .then((response: SchedulingWorkshiftModelAPI) =>
                createWorkshiftsSchedulingAdapter(response)
            );
    },

    deleteWorkshiftScheduling: (body: DeleteWorkshiftsSchedulingBody) => {
        return requests.deleteWithBody(
            '/jerusalem/api/v2.0.0/workshift-schedulings/delete-workshift-schedulings',
            body
        );
    },

    saveExceptionalWorkshiftsScheduling: (body: {
        workshiftSchedulingIds: number[];
    }) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/workshift-schedulings/convert-to-exceptional',
                body
            )
            .then((res) => res);
    },

    removeExceptionalWorkshiftsScheduling: (body: {
        workshiftSchedulingIds: number[];
    }) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/workshift-schedulings/remove-exceptional-workshift',
                body
            )
            .then((res) => res);
    },

    getListScheduling: (body: {
        startDate: string;
        endDate: string;
        employeeIds: (number | string)[];
    }) => {
        return requests
            .post(
                '/jerusalem/api/v2.0.0/workshift-schedulings/list-schedulings',
                body
            )
            .then((res) => res);
    },

    savePasteWorkshiftsSchedulings: (body: {
        startDate: string;
        endDate: string;
        employeeIds: (number | string)[];
        copyRanges: WorkshiftSchedulingsIds[];
    }) => {
        return requests
            .post(
                '/jerusalem/api/v2.0.0/workshift-schedulings/duplicate-workshift-schedulings',
                body
            )
            .then((res) => res);
    },

    validateWorkshiftsExceptionals: (body: {
        startDate: string;
        endDate: string;
        employeeIds: (number | string)[];
    }) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/workshift-schedulings/liquidate-exceptional-workshifts',
                body
            )
            .then((res) => res);
    },

    importSchedulings: (data: FormData) => {
        return requests
            .post(
                '/jerusalem/api/v2.0.0/employees/import-schedulings-from-template/',
                data
            )
            .then((res) => res);
    },

    validateWorkshiftsSundaysUsuals: (body: {
        startDate: string;
        endDate: string;
        employeeIds: (number | string)[];
    }) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/workshift-schedulings/get-workshifts-sundays-usuals',
                body
            )
            .then((res) => res);
    },
};
